<template>
    <el-dialog
    title="详情"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="85rem">
        <div class="top-box">
           <div class="first-line">
            <div class="item">
                <p class="title-style">任务名称：</p>
                <el-tooltip class="item" effect="dark" :content="detail.taskName" placement="top-start">
                    <p class="overflow">{{ detail.taskName }}</p>
                </el-tooltip>
            </div>
            <div class="item">
                <p class="title-style">开始时间：</p>
                <el-tooltip class="item" effect="dark" :content="detail.beginTime+'分钟'" placement="top-start">
                    <p class="overflow" style="width: 18rem;">{{ detail.beginTime+'分钟' }}</p>
                </el-tooltip>
            </div>
            <div class="item">
                <p class="title-style">结束时间：</p>
                <el-tooltip class="item" effect="dark" :content="detail.endTime" placement="top-start">
                    <p class="overflow">{{detail.endTime}}</p>
                </el-tooltip>
            </div>
           </div>
           <div class="relate-item">
                <p class="title-style">关联班级：</p>
                <div class="class-item-box">
                    <div v-for="(item,index) in detail.refClassInfoList" class="class-item" :key="index">
                        <div>{{ item.className }}</div>
                        <div v-if="index<detail.refClassInfoList.length-1">，</div>
                    </div>
                </div>
           </div>
        </div>
        <div class="content">
            <no-data v-if="!detail.refSoftWareInfoList||detail.refSoftWareInfoList.length==0"></no-data>
            <div style="display: flex;">
                <div class="title-style">关联软件：</div>
                <div class="item-box">
                    <div class="content-item" v-for="(item,index) in detail.refSoftWareInfoList&&detail.refSoftWareInfoList" :key="index">
                    <div class="item">
                        <el-tooltip effect="dark" :content="item.softwareName" placement="top-start">
                                <p style="width: 100%;" class="overflow">{{ index+1+'.'+item.softwareName }}</p>
                        </el-tooltip>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import NoData from '../../common/NoData.vue'
    export default {
  components: { NoData },
        data(){
            return {
                dialogVisible:false,
                /**详情 */
                detail:{},
            }
        },
        methods:{
           
        }
    }
</script>

<style lang="less" scoped>
/deep/.el-dialog__title{
    font-size: 16px;
    font-weight: 700;
}
/deep/.el-dialog{
    border-radius: 16px;
}
/deep/.el-dialog__body{
    padding:0 5rem 5rem 5rem;
}
/deep/.el-dialog__header{
    padding: 3rem 5rem;
}
.first-line{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.item{
        display: flex;
        align-items: center;
        &> :nth-child(2){
            width: 15rem;
        }
    }
.top-box{
    color: #334681;
    padding-bottom: 2.8rem;
    border-bottom: 1px solid #E0E8F2;
    &> :nth-child(n){
        margin-top: 2rem;
    }
    &> :nth-child(1){
        margin-top: 0;
    }
}
.title-style{
    color: #8590B3;
    width: 7rem;
    text-align: right;
}
.relate-item{
    display: flex;
    &> :nth-child(2){
        width: calc(100% - 8rem);
        p{
            width: 100%;
        }
    }
}
.item-box{
    &> :nth-child(n){
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 2.2rem;
        color: #334681;
    }
    &> :nth-child(1){
        margin-top: 0;
    }
}
.content{
    height: 40rem;
    overflow: auto;
    margin-top: 2rem;
}
.class-item-box{
    display: flex;
    flex-wrap: wrap;
}
.class-item{
    display: flex;
    white-space: var(--lineWrap);
}
</style>